export const INPUT_ACTIONS = Object.freeze([
  'strike',
  'sprint',
  'scent',
  'interact',
  'ability',
  'pause',
  'devTools',
]);

export const KEY_BINDINGS = Object.freeze({
  moveForward: Object.freeze(['KeyW', 'ArrowUp']),
  moveBackward: Object.freeze(['KeyS', 'ArrowDown']),
  moveLeft: Object.freeze(['KeyA', 'ArrowLeft']),
  moveRight: Object.freeze(['KeyD', 'ArrowRight']),
  strike: Object.freeze(['Space']),
  sprint: Object.freeze(['ShiftLeft', 'ShiftRight']),
  scent: Object.freeze(['KeyQ']),
  interact: Object.freeze(['KeyE']),
  ability: Object.freeze(['KeyR']),
  pause: Object.freeze(['Escape']),
  devTools: Object.freeze(['F1']),
});

export const POINTER_BINDINGS = Object.freeze({
  strike: 0,
});

export const GAMEPAD_BINDINGS = Object.freeze({
  strike: 0,
  ability: 1,
  interact: 2,
  scent: 4,
  sprint: 10,
  pause: 9,
});

export const GAMEPAD_AXES = Object.freeze({
  moveX: 0,
  moveY: 1,
  lookX: 2,
  lookY: 3,
});
